export default __webpack_public_path__ + "static/media/panos_pizza_1.5b7f20ff.png";